import { ref } from "vue";

export const status = ref()
export const card = ref()
export const dafAmount = ref()
